<template>
    <div class="exchange-confirm" v-if="false">
        <div class="exchange-confirm__content">
            <div class="main_img">
                <img src="@/assets/images/confirm-icon.svg" alt="">
            </div>
            <p class="description">Подтвердите действие</p>
            <h3 class="title">Обмен валют между счетами</h3>
            <div class="exchange_block">
                <div class="exchange_card">
                    <div class="exchange_card__top">
                        <h4>Из</h4>
                        <p>
                            На счету:
                            <span>1 152 162.00</span>
                            <span class="text-accent">MAX</span>
                        </p>
                    </div>
                    <div class="exchange_card__bottom">
                        <button>
                            <span>RUB</span>
                        </button>
                        <h3>1 152 162.00 ₽</h3>
                    </div>
                </div>
                <div class="exchange_card">
                    <div class="exchange_card__top">
                        <h4>В</h4>
                        <p>
                            На счету:
                            <span>21 860.02</span>
                        </p>
                    </div>
                    <div class="exchange_card__bottom">
                        <button>
                            <span>USD</span>
                        </button>
                        <h3>12 635.18 $</h3>
                    </div>
                    <div class="line"></div>
                    <div class="exchange_card__foot">
                        <p>
                            <span>Курс:</span>
                            1 USD = 90 RUB
                        </p>
                        <p>
                            <span>Курс:</span>
                            1 USD = 90 RUB
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns">
            <Button @click="$router.go(-1)" title="Отменить"/>
            <Button @click="modal_active = true" title="Подтвердить"/>
        </div>
    </div>
    <PayModal @closeModal="closeModal()" v-if="modal_active" stage="success" />
</template>

<script>
import Button from '@/components/Button.vue';
import PayModal from '@/components/PayModal.vue';
export default {
    name: "Exchange Confirm",
    components: {
        Button,
        PayModal,
    },
    data () {
        return {
            modal_active: false
        }
    },
    methods: {
        closeModal() {
            this.modal_active = false;
        }
    }
}
</script>

<style>

</style>